import { createAction } from '@reduxjs/toolkit';

const getMaterialsSuccess = createAction('supplies/getMaterialsSuccess');
const getMaterialsRequest = createAction('supplies/getMaterialsRequest');
const getMaterialsError = createAction('supplies/getMaterialsError');

const duplicateMaterialSuccess = createAction('supplies/duplicateMaterialSuccess');
const duplicateMaterialRequest = createAction('supplies/duplicateMaterialRequest');
const duplicateMaterialError = createAction('supplies/duplicateMaterialError');

const postMaterialSuccess = createAction('supplies/postMaterialSuccess');
const postMaterialRequest = createAction('supplies/postMaterialRequest');
const postMaterialError = createAction('supplies/postMaterialError');
const isPostMaterialSuccessfully = createAction('supplies/isPostMaterialSuccessfully');

const updateMaterialSuccess = createAction('supplies/updateMaterialSuccess');
const updateMaterialRequest = createAction('supplies/updateMaterialRequest');
const updateMaterialError = createAction('supplies/updateMaterialError');


const setMaterialFilters = createAction('supplies/setMaterialFilters');

const getManufacturersSuccess = createAction('supplies/getManufacturersSuccess');
const getManufacturersRequest = createAction('supplies/getManufacturersRequest');
const getManufacturersError = createAction('supplies/getManufacturersError');

const postManufactureSuccess = createAction('supplies/postManufactureSuccess');
const postManufactureRequest = createAction('supplies/postManufactureRequest');
const postManufactureError = createAction('supplies/postManufactureError');
const successfullyAddedManufacturer = createAction('supplies/successfullyAddedManufacturer');

const updateManufactureSuccess = createAction('supplies/updateManufactureSuccess');
const updateManufactureRequest = createAction('supplies/updateManufactureRequest');
const updateManufactureError = createAction('supplies/updateManufactureError');

const deleteManufactureRequest = createAction('supplies/deleteManufactureRequest');
const validationManufactureError = createAction('supplies/validationManufactureError');

const getGlassBeadSuccess = createAction('supplies/getGlassBeadSuccess');
const getGlassBeadRequest = createAction('supplies/getGlassBeadRequest');
const getGlassBeadError = createAction('supplies/getGlassBeadError');

const postGlassBeadSuccess = createAction('supplies/postGlassBeadSuccess');
const postGlassBeadRequest = createAction('supplies/postGlassBeadRequest');
const postGlassBeadError = createAction('supplies/postGlassBeadError');
const successfullyAddedGlassBead = createAction('supplies/successfullyAddedGlassBead');

const updateGlassBeadSuccess = createAction('supplies/updateGlassBeadSuccess');
const updateGlassBeadRequest = createAction('supplies/updateGlassBeadRequest');
const updateGlassBeadError = createAction('supplies/updateGlassBeadError');

const validationGlassBeadError = createAction('supplies/validationGlassBeadError');

const getInventorySuccess = createAction('supplies/getInventorySuccess');
const getInventoryRequest = createAction('supplies/getInventoryRequest');
const getInventoryError = createAction('supplies/getInventoryError');

const inventorySnackBarInfo = createAction('supplies/inventorySnackBarInfo');
const successfullyAdded = createAction('supplies/successfullyAdded');

const postInventorySuccess = createAction('supplies/postInventorySuccess');
const postInventoryRequest = createAction('supplies/postInventoryRequest');
const postInventoryError = createAction('supplies/postInventoryError');

const updateInventorySuccess = createAction('supplies/updateInventorySuccess');
const updateInventoryRequest = createAction('supplies/updateInventoryRequest');
const updateInventoryError = createAction('supplies/updateInventoryError');

const deleteInventoryRequest = createAction('supplies/deleteInventoryRequest');

const getInventoryAvailableGlassBeadsSuccess = createAction('supplies/getInventoryAvailableGlassBeadsSuccess');
const getInventoryAvailableGlassBeadsError = createAction('supplies/getInventoryAvailableGlassBeadsError');

const setSurfaces = createAction('supplies/surfaces/setSurfaces');
const addSurface = createAction('supplies/surfaces/addSurface');
const updateSurface = createAction('supplies/surfaces/updateSurface');
const deleteSurface = createAction('supplies/surfaces/deleteSurface');

export default {
  // Materials
  getMaterialsSuccess,
  getMaterialsRequest,
  getMaterialsError,
  postMaterialSuccess,
  postMaterialRequest,
  postMaterialError,
  updateMaterialSuccess,
  updateMaterialRequest,
  updateMaterialError,
  duplicateMaterialSuccess,
  duplicateMaterialRequest,
  duplicateMaterialError,
  isPostMaterialSuccessfully,
  setMaterialFilters,
  // Manufacturer
  getManufacturersSuccess,
  getManufacturersRequest,
  getManufacturersError,
  postManufactureSuccess,
  postManufactureRequest,
  postManufactureError,
  updateManufactureSuccess,
  updateManufactureRequest,
  updateManufactureError,
  deleteManufactureRequest,
  successfullyAddedManufacturer,
  validationManufactureError,
  // Inventory
  successfullyAdded, // ??
  inventorySnackBarInfo,
  getInventorySuccess,
  getInventoryRequest,
  getInventoryError,
  postInventorySuccess,
  postInventoryRequest,
  postInventoryError,
  updateInventorySuccess,
  updateInventoryRequest,
  updateInventoryError,
  deleteInventoryRequest,
  getInventoryAvailableGlassBeadsSuccess,
  getInventoryAvailableGlassBeadsError,
  // Glass Beads
  getGlassBeadSuccess,
  getGlassBeadRequest,
  getGlassBeadError,
  postGlassBeadSuccess,
  postGlassBeadRequest,
  postGlassBeadError,
  successfullyAddedGlassBead,
  updateGlassBeadSuccess,
  updateGlassBeadRequest,
  updateGlassBeadError,
  validationGlassBeadError,
  // Surfaces
  setSurfaces,
  addSurface,
  updateSurface,
  deleteSurface,
};
